import { commonFilter } from './filter';

export const MahjongTopCreativesPoint = {
  pageName: 'MahjongSolitaire Top Creatives',
  pageId: '25107',
  pagePath: '/marketing/MahjongSolitaire/TopCreatives',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    TypeSegment: {
      buttonId: '2510701',
    },
    Download: {
      buttonId: '2510702',
    },
    AdCover: {
      buttonId: '2510703',
    },
    AdTitle: {
      buttonId: '2510704',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const ArrowsTopCreativesPoint = {
  pageName: 'Arrows Top Creatives',
  pageId: '25108',
  pagePath: '/marketing/Arrows/TopCreatives',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    TypeSegment: {
      buttonId: '2510801',
    },
    Download: {
      buttonId: '2510802',
    },
    AdCover: {
      buttonId: '2510803',
    },
    AdTitle: {
      buttonId: '2510804',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const Merge2TopCreativesPoint = {
  pageName: 'Merge-2 Top Creatives',
  pageId: '25117',
  pagePath: '/marketing/Merge2/TopCreatives',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    TypeSegment: {
      buttonId: '2511701',
    },
    Download: {
      buttonId: '2511702',
    },
    AdCover: {
      buttonId: '2511703',
    },
    AdTitle: {
      buttonId: '2511704',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const Merge3TopCreativesPoint = {
  pageName: 'Merge-3 Top Creatives',
  pageId: '25118',
  pagePath: '/marketing/Merge3/TopCreatives',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    TypeSegment: {
      buttonId: '2511801',
    },
    Download: {
      buttonId: '2511802',
    },
    AdCover: {
      buttonId: '2511803',
    },
    AdTitle: {
      buttonId: '2511804',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};
